import CircularProgress from "@material-ui/core/CircularProgress";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";
import { layoutContentMarginTop } from "../../style";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: "absolute",
      top: `calc(50% - ${(200 + layoutContentMarginTop.mobile) / 2}px + 5px)`,
      left: "calc(50% - 100px)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "200px",
      height: "200px",
      [theme.breakpoints.up("sm")]: {
        top: `calc(50% - ${(200 + layoutContentMarginTop.nonMobile) / 2}px + 5px)`,
      },
    },
    container: {
      maxWidth: "50%",
    },
    icon: {
      width: 50,
      height: 50,
    },
    message: {
      marginTop: "1rem",
      textAlign: "center",
      color: theme.palette.text.primary,
      fontSize: "1rem",
      fontWeight: 400,
    },
  });

interface LoaderProps extends WithStyles<typeof styles> {
  loadingText?: string;
}

export const LoaderComponent = (props: LoaderProps) => {
  const { loadingText, classes } = props;
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <CircularProgress className={classes.icon} />
      </div>
      <div className={classes.message}>{loadingText || "Loading"}...</div>
    </div>
  );
};

export const Loader = withStyles(styles)(LoaderComponent);
